import React from 'react'
import './section_title.css'

const Section_title = ({ title, alltotal }) => {
  return (
    <>
      <div className='section_title_div theme_bg'>
        <h6 className='sectitle'>{title}</h6>
        <h6 className='sectitle'>{alltotal}</h6>
      </div>
    </>
  )
}

export default Section_title